/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // console.log('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  console.log("Updating cart (updateCartNote)...");
  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(note),
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  // Robust: bei 429/5xx/HTML-Antworten oder leerem Body warf eval(...) selbst eine Exception
  // im Error-Handler. JSON.parse in try/catch -> Fehler bleibt sauber gefangen.
  var data = {};
  try { data = JSON.parse(XMLHttpRequest.responseText || "{}"); } catch (e) {}
  if (!!data.message) {
    console.log(
      "Error: " + data.message + "(" + data.status + "): " + data.description
    );
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery(form).serialize(),
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item, form);
        console.log("Item added.");
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  "use strict";

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer,
    $upsellButton,
    $addToCartReturnButton;
  // Private functions
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    addToCartReturn,
    createQtySelectors,
    qtySelectors,
    validateQty,
    closeCart,
    validateFreeShipping,
    upsellButton,
    renderUpsellButton,
    renderUpsellMetafield;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "#CartContainer",
      addToCartSelector: ".enj-add-to-cart-btn",
      addToCartReturnSelector: ".enj-add-to-cart-return",
      upsellButtonSelector: "#UpsellButton",
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: "$",
      disableAjaxCart: false,
      enableQtySelectors: true,
      enableUpsell: true,
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $upsellButton = $(settings.upsellButtonSelector);
    $addToCartReturnButton = $(settings.addToCartReturnSelector);

    // General Selectors
    $body = $("body");

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableUpsell) {
      // upsellButton();
      renderUpsellButton();
    }

    addToCartReturn();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    closeCart();
  };

  window.addEventListener(
    "DOMContentLoaded",
    (event) => {
      ShopifyAPI.getCart(cartUpdateCallback);
      addToCartReturn();
    },
    { passive: true }
  );

  loadCart = function () {
    $body.addClass("drawer--is-loading");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass("hidden-count");

      if (cart.item_count === 0) {
        $cartCountSelector.addClass("hidden-count");
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(
        Shopify.formatMoney(cart.total_price, settings.moneyFormat)
      );
    }
  };

  formOverride = function () {
    $formContainer.on("submit", function (evt) {
      evt.preventDefault();
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass("is-added").addClass("is-adding");
      $addToCart_btn
        .find("i")
        .replaceWith(
          '<i class="enj-loader-add-to-cart"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>'
        );

      // Remove any previous quantity errors
      $(".qty-error").remove();

      var variantId = evt.target.getAttribute("data-variant");

      // ATC-Funnel-Event (dataLayer -> GTM -> GA4/PostHog). Schliesst die Luecke
      // product_viewed -> checkout_started im mobilen Funnel (PostHog-Evidence-Doc).
      if (window.klTrack) {
        var klBtn = $addToCart_btn[0];
        window.klTrack("atc_clicked", {
          variant_id: $(evt.target).find('[name="id"]').val() || variantId,
          product_sku: klBtn && klBtn.getAttribute("data-ph-capture-attribute-product-sku"),
          product_price: klBtn && klBtn.getAttribute("data-ph-capture-attribute-product-price")
        });
      }

      ShopifyAPI.addItemFromForm(
        evt.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  renderUpsellButton = function () {
    // Cart-Upsell ist rein metafield-getrieben (custom.cart_upgrade / custom.cart_addons via
    // templates/product.upsell.liquid). settings.cart_upsell_metafield = Kill-Switch: AUS -> kein
    // Upsell. Das frueher hardcodierte KLAMER-SKU-Mapping wurde entfernt (portabel fuer alle Shops).
    if (true) {
      renderUpsellMetafield();
    }
  };

  // === P2-A: Metafield-getriebener Upsell ===
  // Quelle: /products/{handle}?view=upsell (kuratierte custom.cart_upgrade /
  // custom.cart_addons je Cart-Produkt). Exakte Varianten, .available-gefiltert,
  // Preis kommt vorformatiert (NICHT /100). Pro Zeile data-upgrade-from →
  // Upgrade reduziert die richtige Basis-Variante (behebt den alten Shared-Bug).
  renderUpsellMetafield = function () {
    var $div = $("body").find("#upsellButtonDiv");
    var esc = function (s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"); };
    var clear = function () {
      try { var $s = $div.find(".slick-upsell"); if ($s.length && $s.hasClass("slick-initialized")) $s.slick("unslick"); } catch (e) {}
      $div.find(".slick-upsell").remove();
    };
    // Render-Token: bei schnellen buildCart-Aufrufen darf ein langsamerer alter
    // Fetch nicht NACH einem neueren rendern (Stale-Render-Race).
    var myGen = (window.__klMfGen = (window.__klMfGen || 0) + 1);
    Shopify.getCart(function (cart) {
      if (myGen !== window.__klMfGen) return;
      if (!cart.items || !cart.items.length || cart.items.length >= 3) { clear(); $div.addClass("hidden"); return; }
      var inCart = {}; cart.items.forEach(function (i) { inCart[String(i.variant_id)] = true; });
      var lineByHandle = {};
      cart.items.forEach(function (i) { (lineByHandle[i.handle] = lineByHandle[i.handle] || []).push(String(i.variant_id)); });
      var handles = Object.keys(lineByHandle);
      Promise.all(handles.map(function (h) {
        return fetch("/products/" + encodeURIComponent(h) + "?view=upsell")
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data) return [];
            var from = lineByHandle[h] || [];
            var list = [];
            (data.upgrades || []).forEach(function (u) { list.push({ kind: "upgrade", v: u, from: from }); });
            (data.addons || []).forEach(function (a) { list.push({ kind: "upsell", v: a, from: from }); });
            return list;
          })
          .catch(function () { return []; });
      })).then(function (lists) {
        if (myGen !== window.__klMfGen) return;
        var cands = [].concat.apply([], lists), seen = {};
        cands = cands.filter(function (c) {
          var id = String(c.v.variant_id);
          if (!c.v.variant_id || c.v.available === false) return false;
          if (inCart[id] || seen[id]) return false;
          seen[id] = true; return true;
        });
        cands.sort(function (a, b) { return (a.kind === "upgrade" ? 0 : 1) - (b.kind === "upgrade" ? 0 : 1); });
        clear();
        if (!cands.length) { $div.addClass("hidden"); return; }
        $div.removeClass("hidden");
        // Layout kommt aus fix_style.css (.kl-upsell-row, display:flex !important):
        // slick ueberschreibt das INLINE-display der Slide-Inhalte mit inline-block
        // (width:100%) und zerlegte so die frueheren inline-flex-Rows -> Titel/Preis/
        // CTA fielen unter die 60px-Box (Prod-Bug, alle Metafield-Upsells betroffen).
        var rows = cands.map(function (c, idx) {
          var isUp = c.kind === "upgrade", w = isUp ? "100px" : "75px";
          var icon = isUp
            ? '<i class="fa fa-arrow-up" aria-hidden="true"></i><span style="float:right;margin-top:1px">Upgrade</span>'
            : '<i class="fa fa-plus" aria-hidden="true"></i><span style="float:right;margin-top:1px">Dazu</span>';
          return '<div class="kl-upsell-row">'
            + '<a class="kl-upsell-img" href="' + esc(c.v.url) + '"><img src="' + esc(c.v.image) + '" alt=""></a>'
            + '<a class="kl-upsell-info" href="' + esc(c.v.url) + '"><div class="upsell-button-product-title">' + esc(c.v.title) + '</div>'
            + '<div class="kl-upsell-price">' + esc(c.v.price) + '</div></a>'
            + '<div class="kl-upsell-cta" style="width:' + w + ';">'
            + '<a class="upsell-button kl-mf-upsell" id="UpsellButton-mf-' + idx + '" data-upsell-type="' + c.kind + '" data-upsell-title="' + esc(c.v.title) + '" data-variant="' + esc(c.v.variant_id) + '" data-upgrade-from="' + esc(c.from.join(",")) + '" href="#" style="width:' + w + ';">' + icon + '</a>'
            + '</div></div>';
        });
        $div.append('<div class="slick-upsell">' + rows.join("") + '</div>');
        // Slick nur bei >1 Kandidat (1 Slide braucht kein Carousel; infinite:false
        // verhindert Clone-Slides, die die Kandidaten verdreifachen).
        if (cands.length > 1) {
          try {
            $(".slick-upsell").slick({
              infinite: false,
              slidesToShow: 1,
              prevArrow: '<button type="button" class="upsell-switch slick-prev" style="left:-25px !important;"></button>',
              nextArrow: '<button type="button" class="upsell-switch slick-next" style="right:-25px !important;">Next</button>',
            });
          } catch (e) {}
        }
      });
    });

    // Add-Handler einmalig delegiert binden (kein Doppel-Binding bei Re-Render).
    if (!window.__klMfUpsellBound) {
      window.__klMfUpsellBound = true;
      $("body").on("click", ".kl-mf-upsell", function (evt) {
        evt.preventDefault();
        var el = evt.currentTarget;
        var variantId = el.getAttribute("data-variant");
        var type = el.getAttribute("data-upsell-type");
        try { dataLayer.push({ event: "upsell-button-click", upsellItem: el.getAttribute("data-upsell-title") }); } catch (e) {}
        if (type === "upgrade") {
          var from = (el.getAttribute("data-upgrade-from") || "").split(",").filter(Boolean);
          Shopify.getCart(function (cart) {
            var updates = {};
            cart.items.forEach(function (it) { if (from.indexOf(String(it.variant_id)) !== -1) updates[it.variant_id] = Math.max(0, it.quantity - 1); });
            updates[variantId] = (updates[variantId] || 0) + 1;
            $.post("/cart/update.js", { updates: updates }).always(function () { Shopify.getCart(itemAddedCallback); });
          });
        } else {
          Shopify.addItem(variantId, 1, itemAddedCallback, itemErrorCallback);
        }
      });
    }
  };


  addToCartReturn = function () {
    // Namespaced + off-before-on: addToCartReturn() wird zweimal aufgerufen (DOMContentLoaded +
    // cartUpdateCallback) -> sonst mehrfach gebundener Click = Mehrfach-Add. Dieser Handler
    // (Shopify.addItem + itemAddedCallback) ist der kanonische -> oeffnet das Cart-Drawer.
    $("#AddToCartReturn").off("click.klReturn").on("click.klReturn", function (evt) {
      console.log("Adding return item...");
      evt.preventDefault();

      const variantId = evt.currentTarget.getAttribute("data-variant");
      console.log("variantId: ", variantId);

      // dataLayer.push({
      //   event: "upsell-button-click",
      //   upsellItem: upsellItemTitle,
      // });

      // const variantId = evt.currentTarget.getAttribute("data-variant");
      // const upsellType = evt.currentTarget.getAttribute("data-upsell-type");

      Shopify.addItem(variantId, 1, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    if (window.klTrack) {
      window.klTrack("atc_succeeded", {
        variant_id: product && product.id,
        product_title: product && product.product_title,
        product_price: product && product.price
      });
    }
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass("is-adding").addClass("is-added");
    $addToCart_btn
      .find(".enj-loader-add-to-cart")
      .html('<i class="fa fa-check"></i>');

    $(".product-popup").find(".product-name").html(product.product_title);
    $(".product-popup").find(".product-image img").attr("src", product.image);

    const windowWidth = jQuery(window).width();

    ShopifyAPI.getCart(cartUpdateCallback);

    if (windowWidth > 767) {
      // showPopup('.product-popup');
      $(".icon-cart").toggleClass("active");
      if (!$("body").hasClass("pushmenu-push-toright-cart")) {
        $("body").toggleClass("pushmenu-push-toright-cart");
        $(".pushmenu-left").toggleClass("pushmenu-open");
      }
      $(".container").toggleClass("canvas-container");
    } else {
      $(".icon-cart").toggleClass("active");
      if (!$("body").hasClass("pushmenu-push-toright-cart")) {
        $("body").toggleClass("pushmenu-push-toright-cart");
        $(".pushmenu-left").toggleClass("pushmenu-open");
      }
      // $('body').toggleClass('pushmenu-push-toright-cart');
      // $('.pushmenu-left').toggleClass('pushmenu-open');
      // $(".container").toggleClass("canvas-container");
    }
    // renderUpsellButton()
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    console.log("Error: ", XMLHttpRequest.responseText);
    console.log("textStatus: ", textStatus);
    // Robust: bei nicht-JSON/leeren Fehlerantworten (schlechtes Mobilnetz, 429/5xx, HTML)
    // warf eval(...) hier erneut -> Button blieb im Spinner haengen. JSON.parse in try/catch.
    var data = {};
    try { data = JSON.parse(XMLHttpRequest.responseText || "{}"); } catch (e) {}
    if (window.klTrack) {
      window.klTrack("atc_failed", {
        status: XMLHttpRequest && XMLHttpRequest.status,
        message: (data && data.description) || (data && data.message) || textStatus
      });
    }
    $addToCart.removeClass("is-adding is-added");
    $addToCart.find(".enj-loader-add-to-cart").remove();

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after(
          '<div class="errors qty-error">' + data.description + "</div>"
        );
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price

    $(".enj-cartcount").html(cart.item_count);
    $(".enj-cartcount").css({ opacity: 1 });

    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    console.log("Building cart...");

    // Show empty cart
    if (cart.item_count === 0) {
      var source = $("#CartEmpty").html(),
        template = Handlebars.compile(source);

      // Append new quantity selector then remove original
      $cartContainer.append(template());
      // P2-E: zuletzt angesehene Produkte in den leeren Drawer rendern
      // (Script im injizierten #CartEmpty läuft via innerHTML nicht selbst).
      if (window.klEmptyCartRecos) { window.klEmptyCartRecos(); }
      // .append('<p>' + "Ihr Warenkorb ist im Moment leer." + '</p>');

      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, "_small$1")
          .replace("http:", "");
      } else {
        var prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        // name: cartItem.product_title,
        name: cartItem.product_title,
        variant: cartItem.variant_id,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      count: cart.item_count,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
    };

    $cartContainer.append(template(data));

    validateFreeShipping(cart.total_price);

    renderUpsellButton();

    cartCallback(cart);
  };

  cartCallback = function (cart) {
    $body.removeClass("drawer--is-loading");
    $body.trigger("ajaxCart.afterCartLoad", cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on("click", ".ajaxcart__qty-adjust", function () {
      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.siblings(".ajaxcart__qty-num"),
        qty = parseInt($qtySelector.val().replace(/\D/g, ""));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      console.log("Qty: " + qty);

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
        // Analytics: Mengenaenderung im Cart-Drawer (dataLayer -> GTM -> GA4/PostHog). qty 0 = Entfernen.
        try {
          if (window.klTrack) {
            if (qty <= 0) {
              window.klTrack("remove_from_cart", { line: line, source: "qty_minus" });
            } else {
              window.klTrack("cart_quantity_changed", {
                line: line,
                quantity: qty,
                direction: $el.hasClass("ajaxcart__qty--plus") ? "increase" : "decrease",
              });
            }
          }
        } catch (e) {}
      } else {
        $qtySelector.val(qty);
      }
    });

    // Remove item (set quantity to 0)
    $body.on("click", "#product-remove", function () {
      var $el = $(this),
        line = $el.attr("line"),
        variant = $el.attr("variant");

      var qty = 0;

      // Analytics: Entfernen ueber den Loeschen-Button (dataLayer -> GTM -> GA4/PostHog).
      try { if (window.klTrack) window.klTrack("remove_from_cart", { line: line, variant_id: variant, source: "remove_button" }); } catch (e) {}

      ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on("focus", ".ajaxcart__qty-adjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
        "is-loading"
      );

      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on("change", 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
    }, 350);
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            variant: $el.attr("variant"),
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id"),
          variant = $el.attr("variant");
        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
            variant: variant,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $(".js-qty__adjust").on("click", function () {
        var $el = $(this),
          id = $el.data("id"),
          $qtySelector = $el.siblings(".js-qty__num"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));

        var variant =
          $el.next().attr("variant") && $el.next().attr("variant").length > 0
            ? $el.next().attr("variant")
            : $el.prev().attr("variant");

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass("js-qty__adjust--plus")) {
          qty += 1;
          updatePricingQty(qty);
          var changes = {
            updates: {
              [variant]: qty,
            },
          };
          $.post("/cart/update.js", changes);

          setTimeout(() => {
            ShopifyAPI.getCart((cart) => {
              // Adjust total price
              var price = "€" + cart.total_price / 100.0;
              var cleanPrice = price.replace(".", ",");
              const $priceElement = $(".price-total");
              $priceElement.text(cleanPrice);
              $priceElement
                .addClass("price-total-animate")
                .delay(1000)
                .queue(() => {
                  // Wait for 1 second.
                  $priceElement.removeClass("price-total-animate").dequeue();
                });

              // Check if it changes free shipping
              validateFreeShipping(cart.total_price);
            });
          }, 200);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
          var changes = {
            updates: {
              [variant]: qty,
            },
          };
          $.post("/cart/update.js", changes);

          setTimeout(() => {
            ShopifyAPI.getCart((cart) => {
              var price = "€" + cart.total_price / 100;
              var cleanPrice = price.replace(".", ",");
              const $priceElement = $(".price-total");
              $priceElement.text(cleanPrice);
              $priceElement
                .addClass("price-total-animate")
                .delay(1000)
                .queue(() => {
                  // Wait for 1 second.
                  $priceElement.removeClass("price-total-animate").dequeue();
                });
              // Fix: vorher stand dieser Aufruf AUSSERHALB des getCart-Callbacks -> "cart" war
              // dort nicht definiert; Versandkosten-Zeile konnte nach Mengenaenderung falsch bleiben.
              validateFreeShipping(cart.total_price);
            });
          }, 100);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateFreeShipping = (totalCart) => {
    // Schwelle aus Theme-Einstellung (Cent); Default 44 € = bisheriges Verhalten.
    const threshold = 4400;
    const $freeShipping = $(".free-shipping-reached");
    const $noFreeShippingNot = $(".free-shipping-not-reached");

    if (totalCart >= threshold) {
      $freeShipping.removeClass("hidden");
      $noFreeShippingNot.addClass("hidden");
    } else {
      $freeShipping.addClass("hidden");
      $noFreeShippingNot.removeClass("hidden");
    }

    // Fortschrittsbalken: Füllbreite + Restbetrag bis zur Schwelle.
    var pct = threshold > 0 ? Math.min(100, Math.round((totalCart / threshold) * 100)) : 100;
    var remaining = Math.max(0, threshold - totalCart);
    $(".kl-fs-fill").css("width", pct + "%");
    $(".kl-fs-remaining").html(Shopify.formatMoney(remaining, settings.moneyFormat));
  };

  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  closeCart = function () {
    $body.on("click", "#cartMenuClose", function () {
      var $el = $(".pushmenu-left");
      $el.removeClass("pushmenu-open");
      $("body").removeClass("pushmenu-push-toleft");
      $("body").removeClass("pushmenu-push-toright-cart");
    });

    // "Produkte suchen" im leeren Warenkorb: Cart schliessen, dann die passende Suche oeffnen.
    // Desktop hat die Header-Suche (#kl-dqs-input) direkt sichtbar -> dorthin fokussieren;
    // das MOBILE Menue einzublenden wirkte auf Desktop wie "Menü geht auf" (User 2026-07-14).
    // Mobil bleibt das Menue (dort lebt die Suche) und der Fokus auf dessen Suchfeld.
    $body.on("click", ".cart-search-btn", function (e) {
      e.preventDefault();
      // Close cart
      var $el = $(".pushmenu-left");
      $el.removeClass("pushmenu-open");
      $("body").removeClass("pushmenu-push-toleft");
      $("body").removeClass("pushmenu-push-toright-cart");
      var dqs = document.getElementById("kl-dqs-input");
      if (dqs && dqs.offsetParent) {
        setTimeout(function () { dqs.focus(); }, 150);
        return;
      }
      // Open mobile menu
      setTimeout(function () {
        $(".menu-home5").addClass("pushmenu-open");
        $("body").addClass("pushmenu-push-toleft");
        // Focus search input after menu opens
        setTimeout(function () {
          $("#mobile-search-form-input").focus();
        }, 300);
      }, 100);
    });
  };

  module = {
    init: init,
    load: loadCart,
  };

  return module;
})(ajaxCart || {}, jQuery);
